import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  ILLUSTRATION_CATEGORIES,
  ILLUSTRATIONS,
  getIllustrationCategoryLabel,
} from '../data/illustrations';
import './Illustrations.css';

function IllustrationSvg({ item }) {
  const { accent, scene, title } = item;
  const common = {
    viewBox: '0 0 320 240',
    role: 'img',
    'aria-label': title,
    xmlns: 'http://www.w3.org/2000/svg',
  };

  const background = (
    <>
      <rect width="320" height="240" rx="20" fill="#fffaf1" />
      <circle cx="265" cy="52" r="34" fill={accent} opacity="0.18" />
      <circle cx="56" cy="196" r="42" fill="#7bc6b1" opacity="0.16" />
    </>
  );

  if (scene === 'bible') {
    return (
      <svg {...common}>
        {background}
        <path d="M68 82c38-18 67-13 92 5v90c-26-20-57-24-92-5V82z" fill="#fff" stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
        <path d="M160 87c25-18 54-23 92-5v90c-35-19-66-15-92 5V87z" fill="#fff" stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
        <path d="M160 88v88" stroke="#2f3437" strokeWidth="5" strokeLinecap="round" />
        <path d="M91 111h42M91 133h46M185 111h48M185 133h37" stroke={accent} strokeWidth="7" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'pray') {
    return (
      <svg {...common}>
        {background}
        <circle cx="160" cy="76" r="33" fill="#ffd8b8" stroke="#2f3437" strokeWidth="7" />
        <path d="M109 192c8-50 26-78 51-78s43 28 51 78" fill={accent} stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
        <path d="M143 132c8 17 17 31 17 52M177 132c-8 17-17 31-17 52" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" />
        <path d="M135 72c11 7 28 7 50 0" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'church') {
    return (
      <svg {...common}>
        {background}
        <path d="M77 126l83-58 83 58v74H77v-74z" fill="#fff" stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
        <path d="M160 68V31M143 48h34" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" />
        <path d="M139 200v-48c0-12 9-22 21-22s21 10 21 22v48" fill={accent} stroke="#2f3437" strokeWidth="7" />
        <path d="M100 144h25M195 144h25" stroke={accent} strokeWidth="9" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'study') {
    return (
      <svg {...common}>
        {background}
        <rect x="61" y="139" width="198" height="44" rx="12" fill="#f1d0a6" stroke="#2f3437" strokeWidth="7" />
        <path d="M82 97c28-13 50-9 68 4v55c-19-15-42-18-68-4V97zM150 101c18-13 40-17 68-4v55c-26-14-49-11-68 4v-55z" fill="#fff" stroke="#2f3437" strokeWidth="6" strokeLinejoin="round" />
        <path d="M232 90h36v44c0 10-8 18-18 18s-18-8-18-18V90z" fill={accent} stroke="#2f3437" strokeWidth="7" />
        <path d="M268 105h16c0 17-7 26-20 26" fill="none" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'candle') {
    return (
      <svg {...common}>
        {background}
        <path d="M159 42c22 25 20 47 0 61-20-14-22-36 0-61z" fill="#ffd65a" stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
        <rect x="128" y="97" width="63" height="92" rx="12" fill="#fff" stroke="#2f3437" strokeWidth="7" />
        <path d="M101 188h118" stroke={accent} strokeWidth="16" strokeLinecap="round" />
        <path d="M82 113c17 0 17-13 34-13s17 13 34 13 17-13 34-13 17 13 34 13" fill="none" stroke={accent} strokeWidth="7" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'hands') {
    return (
      <svg {...common}>
        {background}
        <path d="M74 138c34-35 57-42 71-28 12 12 7 27-10 43l-20 19" fill="#ffd8b8" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M246 102c-34 35-57 42-71 28-12-12-7-27 10-43l20-19" fill="#ffd8b8" stroke="#2f3437" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M109 174l38 34M211 66l-38-34" stroke={accent} strokeWidth="16" strokeLinecap="round" />
      </svg>
    );
  }

  if (scene === 'cross') {
    return (
      <svg {...common}>
        {background}
        <circle cx="160" cy="116" r="58" fill={accent} opacity="0.28" />
        <path d="M160 47v120M123 84h74" stroke="#2f3437" strokeWidth="15" strokeLinecap="round" />
        <path d="M47 190c38-28 66-28 97 0 31-28 62-28 100 0" fill="none" stroke={accent} strokeWidth="10" strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg {...common}>
      {background}
      <rect x="72" y="118" width="176" height="57" rx="12" fill="#f1d0a6" stroke="#2f3437" strokeWidth="7" />
      <path d="M92 118c13-29 37-43 68-43s55 14 68 43" fill="#fff" stroke="#2f3437" strokeWidth="7" strokeLinejoin="round" />
      <path d="M130 82c10 20 20 30 30 30s20-10 30-30" fill="none" stroke={accent} strokeWidth="9" strokeLinecap="round" />
      <circle cx="110" cy="147" r="8" fill={accent} />
      <circle cx="210" cy="147" r="8" fill={accent} />
    </svg>
  );
}

function IllustrationPreview({ item }) {
  if (item.imageSrc) {
    return <img src={item.imageSrc} alt={item.title} />;
  }

  return <IllustrationSvg item={item} />;
}

function downloadPng(item, event) {
  if (item.imageSrc) {
    const link = document.createElement('a');
    link.href = item.imageSrc;
    link.download = `${item.id}.png`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    return;
  }

  const svg = event.currentTarget.closest('.illustration-card')?.querySelector('svg');
  if (!svg) {
    return;
  }

  const source = svg.outerHTML.includes('xmlns=')
    ? svg.outerHTML
    : svg.outerHTML.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
  const svgBlob = new Blob([`<?xml version="1.0" encoding="UTF-8"?>\n${source}`], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(svgBlob);
  const image = new Image();

  image.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = 1600;
    canvas.height = 1200;
    const context = canvas.getContext('2d');
    context.fillStyle = '#fffaf1';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(url);

    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = `${item.id}.png`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  image.onerror = () => {
    URL.revokeObjectURL(url);
  };

  image.src = url;
}

function Illustrations() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('all');

  const filteredItems = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return ILLUSTRATIONS.filter((item) => {
      const categoryMatches = category === 'all' || item.category === category;
      const searchableText = [item.title, getIllustrationCategoryLabel(item.category), ...item.tags].join(' ').toLowerCase();
      const queryMatches = normalizedQuery === '' || searchableText.includes(normalizedQuery);
      return categoryMatches && queryMatches;
    });
  }, [category, query]);

  return (
    <div className="illustrations-page">
      <Header
        title="フリーイラスト素材 | ASMRキリスト教会"
        description="礼拝、聖書、日常、季節行事に使いやすいフリーイラスト素材集。カテゴリと検索から素材を探せます。"
        url="https://www.asmrchurch.com/illust"
      />

      <main className="illustrations-shell">
        <section className="illustrations-hero">
          <div className="illustrations-hero-copy">
            <p className="illustrations-kicker">Free Illustration Library</p>
            <h1>フリーイラスト素材</h1>
            <p>
              教会、聖書、日常の発信に使いやすい、やわらかい雰囲気の素材集です。
              検索とカテゴリから選んで、そのままPNGでダウンロードできます。
            </p>
            <p className="illustrations-handmade">掲載素材はすべて手書きのオリジナル素材です。</p>
          </div>
          <div className="illustrations-hero-art" aria-hidden="true">
            <IllustrationPreview item={ILLUSTRATIONS[0]} />
          </div>
        </section>

        <section className="illustrations-controls" aria-label="イラスト検索">
          <label className="illustrations-search">
            <span>検索</span>
            <input
              type="search"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="例：聖書、祈り、クリスマス"
            />
          </label>

          <div className="illustrations-categories" role="tablist" aria-label="カテゴリ">
            {ILLUSTRATION_CATEGORIES.map((item) => (
              <button
                key={item.id}
                type="button"
                className={category === item.id ? 'is-active' : ''}
                onClick={() => setCategory(item.id)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </section>

        <div className="illustrations-result-line">
          <span>{filteredItems.length}件の素材</span>
          <span>商用・非商用利用可 / クレジット任意</span>
        </div>

        <section className="illustrations-grid" aria-label="素材一覧">
          {filteredItems.map((item) => (
            <article className="illustration-card" key={item.id}>
              <Link className="illustration-preview illustration-card-link" to={`/illust/${item.id}`}>
                <IllustrationPreview item={item} />
              </Link>
              <div className="illustration-card-body">
                <div>
                  <p className="illustration-category">{getIllustrationCategoryLabel(item.category)}</p>
                  <h2>
                    <Link to={`/illust/${item.id}`}>{item.title}</Link>
                  </h2>
                </div>
                <div className="illustration-tags">
                  {item.tags.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </div>
                <button type="button" onClick={(event) => downloadPng(item, event)}>
                  PNGダウンロード
                </button>
              </div>
            </article>
          ))}
        </section>

        {filteredItems.length === 0 && (
          <p className="illustrations-empty">該当する素材がありません。検索語を短くするか、別のカテゴリを選んでください。</p>
        )}

        <section className="illustrations-terms">
          <h2>利用について</h2>
          <p>
            このページの素材は、教会案内、SNS、動画、配布物、学校・個人制作などで自由に使えます。
            素材そのものの再配布・販売、商標登録、公序良俗に反する利用は避けてください。
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Illustrations;
